import { onBeforeUnmount, unref, watch } from 'vue'

import type { Ref } from 'vue'

const HTML_DARK_CLASS = 'dark'
const Z_THEME_ATTR = 'data-z-ui-theme'
let darkRefCount = 0

function syncZTheme(isDark: boolean) {
  if (typeof document === 'undefined') return
  document.documentElement.setAttribute(Z_THEME_ATTR, isDark ? 'dark' : 'light')
}

function applyHtmlDark(enable: boolean) {
  if (typeof document === 'undefined') return
  if (enable) {
    darkRefCount += 1
    if (darkRefCount === 1) {
      document.documentElement.classList.add(HTML_DARK_CLASS)
      syncZTheme(true)
    }
    return
  }
  darkRefCount = Math.max(0, darkRefCount - 1)
  if (darkRefCount === 0) {
    document.documentElement.classList.remove(HTML_DARK_CLASS)
    syncZTheme(false)
  }
}

/** 同步 ConfigProvider.dark 到 document.documentElement（支持嵌套 ref 计数） */
export function useHtmlDark(dark: Ref<boolean | undefined>) {
  let active = false

  const sync = (isDark: boolean) => {
    if (isDark && !active) {
      applyHtmlDark(true)
      active = true
    } else if (!isDark && active) {
      applyHtmlDark(false)
      active = false
    }
  }

  watch(() => !!unref(dark), sync, { immediate: true })

  onBeforeUnmount(() => {
    sync(false)
  })
}
